import React from 'react';
import './Aboutus.scss';
import { GiPikeman, GiCaptainHatProfile, GiCherish } from 'react-icons/gi';
import { FaRegHandshake, FaPeopleCarry, FaArrowAltCircleRight } from 'react-icons/fa';
import { HiLightBulb } from 'react-icons/hi';
import { BiHappyHeartEyes } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';

const Aboutus = () => {
    return (
        <div className="">
            <div className="aboutus-description">
                {/* <div className="col-md-12"><h className="contactus-heading" data-aos="fade-down">What is&nbsp;<span className="sub-contactus-heading">Leo?</span></h></div> */}
                <h2 className="contactus-heading" data-aos="fade-down">Who Are &nbsp;<span className="sub-contactus-heading">We?</span></h2>
                <p className="text-center">Leo Club of Colombo Monarch is a youth driven volunteer organization that serves society by doing various types of charity events voluntarily. We also provide a platform for enthusiastic individuals to develop their skills and talents in Leadership.
                    Being a charter club in the Leo District 306 A2  we focus on taking our good objectives to the international level with the dedication and commitment of our club members who actively enjoys in what we do.</p>
                <div className="aboutus-teambtn justify-content-center">
                    <div className="event-carousel-btn-container justify-content-center">
                        <Link to="/ourteam" style={{ textDecoration: 'none', color: 'rgb(90, 90, 90)' }}>
                            <div className="event-carousel-view-more-btn" data-aos="zoom-in-up"><span>
                                View Our Team
                            </span></div>
                        </Link>
                    </div>
                    {/* <Link to="/ourteam">
                        <Button>View Our Team</Button>
                    </Link> */}
                </div>
            </div>
            <div className="AboutUs-container ">

                <div className="row-container-aboutus  ">

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Become A <b> Volunteer</b> </h3>
                        <p>Become a person who takes social responsibilities.</p>
                        <div className="ben-body">
                            <GiPikeman className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Meet <b>New People</b> </h3>
                        <p>Make new friends while you work as a volunteer.</p>
                        <div className="ben-body">
                            <FaRegHandshake className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Improve <b>Leadership Skills</b></h3>
                        <p>It helps to enhance your soft skills including leadership skills.</p>
                        <div className="ben-body">
                            <GiCaptainHatProfile className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Corparate In <b>Service Projects</b> </h3>
                        <p>Add your contribution to the service projects.</p>
                        <div className="ben-body">
                            <FaPeopleCarry className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Gain <b>Opportunities</b> </h3>
                        <p>Leo movement create lots of opportunities for you.</p>
                        <div className="ben-body">
                            <HiLightBulb className="benifits-icon2" />
                        </div>
                    </div>


                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Make Some <b>Fun With Friends</b> </h3>
                        <p>It's always make fun when best people get together.</p>
                        <div className="ben-body">
                            <BiHappyHeartEyes className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Collect <b>Memories</b> </h3>
                        <p>At the end you can earn a pack of sweet memories.</p>
                        <div className="ben-body">
                            <GiCherish className="benifits-icon2" />
                        </div>
                    </div>

                    <div className="box cyan" data-aos="zoom-in-up">
                        <h3 className="heading-2">Continue To <b>Become A Lion</b> </h3>
                        <p className="benifits-desc">After Leoism continue the journey as a lion.</p>
                        <div className="ben-body">
                            <FaArrowAltCircleRight className="benifits-icon2" />
                        </div>
                    </div>
                    {/*   <Link to="/ourteam">
                        <button>team</button>
                    </Link>
                    <Link to="/projects">
                        <button>projects</button>
                    </Link> */}
                </div>
            </div>
        </div>
    );
};

export default Aboutus;